
import { ColorDto, ConstructColorDto } from '../api/color.dto';
import { Color, ColorId, ConstructionColor, ProfileSideColors } from '../elements/colors';
import { ColorIdLegacy, ColorLegacy } from '../elements/legacy/colors-legacy';
import { IccConstructColorLegacy } from './legacy/construct-color-legacy.dto';
import { IccProfileSideColors } from './side-colors.dto';

export function iccColorToColorLegacy(color: Partial<ConstructColorDto>): ColorLegacy {
    return {
        id: Number(color.id),
        name: color.name,
        code: color.code,
        color: color.color,
        type: color.type,
        color_img: color.color_img,
        RAL: false,
        isDefault: Boolean(color.isDefault),
        groups: (color.groups || []).map(Number),
    };
}

export function iccColorToColorIdLegacy(color: Partial<IccConstructColorLegacy>): ColorIdLegacy {
    return {
        id: Number(color?.id),
        RAL: Boolean(color?.RAL),
        isDefault: Boolean(color?.isDefault),
    };
}

export function iccColorToColorId(color: Partial<ConstructColorDto> | Partial<ColorDto>): ColorId {
    return {
        id: Number(color?.id),
        isDefault: Boolean(color?.isDefault),
    };
}

export function getColorUid(color: ColorIdLegacy) {
    return color.id;
}

export function activeSideColorsToSideColors(
    constrColors: Record<number, ConstructionColor>,
    colors: Record<number, Color>,
    sideColors: ProfileSideColors,
    langCode: string
): IccProfileSideColors {
    return {
        outer:
            sideColors.outer && sideColors.outer.id
                ? convertName(constrColors[getColorUid(sideColors.outer)], langCode)
                : null,
        inner:
            sideColors.inner && sideColors.inner.id
                ? convertName(constrColors[getColorUid(sideColors.inner)], langCode)
                : null,
        core:
            sideColors.core && sideColors.core.id
                ? convertName(colors[getColorUid(sideColors.core)], langCode)
                : null,
        alushell:
            sideColors.alushell && sideColors.alushell.id
                ? convertName(colors[getColorUid(sideColors.alushell)], langCode)
                : null,
    };
}

function convertName<
    T extends {
        name: Record<string, string>;
    }
>(
    obj: T,
    langCode: string
): T & {
    name: string;
} {
    return {
        ...obj,
        name: obj.name[langCode],
    };
}
